/**
 * 后端服务请求 前缀
 */
export enum ServicePrefixEnum {
  // 系统服务
  TENANT = '/system',
  // 文件服务
  FILE = '/base',
  // 消息服务
  MSG = '/base',
  // 网关
  GATEWAY = '/gateway',
  // 认证服务
  OAUTH = '/oauth',
  // 基础服务
  BASE = '/base',
  // 系统服务
  SYSTEM = '/system',
  // 代码生成器服务
  GENERATOR = '/generator',
  // 工作流
  ACTIVITI = '/activiti',
  // 业务流
  PRODUCT = '/product',
  // 在想帮助
  ONLINEHELP = '/onlinehelp',

  EXPORT = '/export',
}

/**
 * 操作列 类型
 */
export enum ActionEnum {
  // 新增
  ADD = 'add',
  // 编辑
  EDIT = 'edit',
  // 复制
  COPY = 'copy',
  // 删除
  DELETE = 'delete',
  // 详情
  VIEW = 'view',
}

export const VALIDATE_API = {
  [ActionEnum.ADD]: 'Save',
  [ActionEnum.EDIT]: 'Update',
  [ActionEnum.COPY]: 'Save',
};

/**
 * 文件的业务 类型
 */
export enum FileBizTypeEnum {
  // 默认库 租户logo
  DEF_TENANT_LOGO = 'DEF__TENANT__LOGO',
  // 默认库 应用logo
  DEF_APPLICATION_LOGO = 'DEF__APPLICATION__LOGO',
  // 基础库 用户头像
  BASE_USER_AVATAR = 'DEF__USER__AVATAR',
  // 基础库 文件中心
  BASE_FILE = 'BASE__FILE',
  // 扩展库 消息内容附件
  EXTEND_MSG_CONTENT = 'EXTEND__MSG__CONTENT',
  // 证明文件库
  PROOF_FILE = 'PROOF_FILE',
}

/**
 * 文件的 桶 （需要提前跟后端约定，并让后端配置到OSS中）
 */
export enum FileBucketEnum {
  // 需要自行在华为云或minio等第三方对象存储提前创建 公开读写的桶
  public = 'tt-public',
}

export enum EnumEnum {
  // msg
  TaskStatus = 'TaskStatus',
  SendStatus = 'SendStatus',
  SourceType = 'SourceType',
  ProviderType = 'ProviderType',
  MsgBizType = 'MsgBizType',
  MsgType = 'MsgType',
  // file
  FileType = 'FileType',
  FileStorageType = 'FileStorageType',
  // tenant
  TenantConnectTypeEnum = 'TenantConnectTypeEnum',
  // authority
  ApplicationAppTypeEnum = 'ApplicationAppTypeEnum',
  TenantStatusEnum = 'TenantStatusEnum',
  TenantTypeEnum = 'TenantTypeEnum',
  Sex = 'Sex',
  AuthorizeType = 'AuthorizeType',
  LogType = 'LogType',
  LoginStatusEnum = 'LoginStatusEnum',
  DataScopeType = 'DataScopeType',
  HttpMethod = 'HttpMethod',

  DateType = 'DateType',
  PopupTypeEnum = 'PopupTypeEnum',
  TplEnum = 'TplEnum',
  EntitySuperClassEnum = 'EntitySuperClassEnum',
  GenTypeEnum = 'GenTypeEnum',
  SqlConditionEnum = 'SqlConditionEnum',
  SuperClassEnum = 'SuperClassEnum',
  ComponentEnum = 'ComponentEnum',
  ProjectTypeEnum = 'ProjectTypeEnum',
  TemplateEnum = 'TemplateEnum',
  FileOverrideStrategyEnum = 'FileOverrideStrategyEnum',

  // test
  ProductType = 'ProductType',
  DefGenTestSimpleType2Enum = 'DefGenTestSimpleType2Enum',
  DefGenTestTreeType2Enum = 'DefGenTestTreeType2Enum',
}
export enum DictEnum {
  // 全局
  GLOBAL_SEX = 'GLOBAL_SEX',
  AREA_LEVEL = 'GLOBAL_AREA_LEVEL',
  NATION = 'GLOBAL_NATION',
  SEX = 'GLOBAL_SEX',
  EDUCATION = 'GLOBAL_EDUCATION',

  // base
  POSITION_STATUS = 'BASE_POSITION_STATUS',
  ORG_TYPE = 'BASE_ORG_TYPE',
  ROLE_CATEGORY = 'BASE_ROLE_CATEGORY',
  EchoDictType_Base_INTERFACE_EXEC_MODE = 'INTERFACE_EXEC_MODE',
  EchoDictType_Base_MSG_TEMPLATE_TYPE = 'MSG_TEMPLATE_TYPE',
  EchoDictType_Base_NOTICE_TARGET = 'NOTICE_TARGET',
  EchoDictType_Base_NOTICE_REMIND_MODE = 'NOTICE_REMIND_MODE',
  EchoDictType_Base_MSG_INTERFACE_LOGGING_STATUS = 'MSG_INTERFACE_LOGGING_STATUS',
  // tenant
  RESOURCE_TYPE = 'TENANT_RESOURCE_TYPE',
  RESOURCE_DATA_SCOPE = 'TENANT_RESOURCE_DATA_SCOPE',
  RESOURCE_OPEN_WITH = 'TENANT_RESOURCE_OPEN_WITH',
  RESOURCE_TRANSITION_NAME = 'TENANT_RESOURCE_TRANSITION_NAME',
  DICT_TYPE = 'TENANT_DICT_TYPE',
  DICT_CLASSIFY = 'TENANT_DICT_CLASSIFY',
  PARAMETER_TYPE = 'TENANT_PARAMETER_TYPE',
  APPLICATION_TYPE = 'TENANT_APPLICATION_TYPE',
  CLIENT_TYPE = 'TENANT_CLIENT_TYPE',
  AREA_SOURCE = 'TENANT_AREA_SOURCE',
  DictionaryType_Global_EDUCATION = 'GLOBAL_EDUCATION',
  DictionaryType_Global_DATA_TYPE = 'DATA_TYPE',

  TENANT_LOGIN_STATUS = 'TENANT_LOGIN_STATUS',
}

export enum MsgTemplateCodeEnum {
  // 注册短信
  REGISTER_SMS = 'REGISTER_SMS',
  // 注册邮件验证码
  REGISTER_EMAIL = 'REGISTER_EMAIL',
  //手机登录短信
  MOBILE_LOGIN = 'MOBILE_LOGIN',
  MOBILE_EDIT = 'MOBILE_EDIT',
  EMAIL_EDIT = 'EMAIL_EDIT',
}

export enum HelpDocEnum {
  ONLINE_HELP_DOCUMENT_LABEL = 'ONLINE_HELP_DOCUMENT_LABEL',
}

export enum MaterialInsertEnum {
  /* ---------  公共   --------- */
  // 转换单位(转换视图)、订单单位(采购视图)、发货单位(存储视图)
  BASE_UNIT = 'BASE_UNIT',
  // 用途字典
  BOM_USED = 'BOM_USED',
  /* ---------  转换视图   --------- */
  // 转换单位

  /* ---------  销售视图   --------- */
  // 工厂 、销售组织
  BASE_FACTORY = 'BASE_FACTORY',
  // 税分类
  TAX_CLASSIFICATION = 'TAX_CLASSIFICATION',
  // 科目分配组
  MATERIAL_ACCOUNT_ALLOCATION_GROUP = 'MATERIAL_ACCOUNT_ALLOCATION_GROUP',
  // 项目类别组
  ITEM_CATEGORY_GROUP = 'ITEM_CATEGORY_GROUP',

  /* ---------  采购视图   --------- */
  // 订单单位
  // 采购组
  BASE_PURCHASING_GROUP = 'BASE_PURCHASING_GROUP',

  /* ---------  MRP视图   --------- */
  // 采购类型
  PROCUREMENT_TYPE = 'PROCUREMENT_TYPE',
  // MRP类型
  MRP_TYPE = 'MRP_TYPE',
  // 特殊采购类
  SPECIAL_PROCUREMENT_CATEGORY = 'SPECIAL_PROCUREMENT_CATEGORY',
  // 外部采购仓储地点
  EXTERNAL_PROCUREMENT_WAREHOUSE_LOCATION = 'EXTERNAL_PROCUREMENT_WAREHOUSE_LOCATION',
  // 生产存储地
  PRODUCTION_STORAGE_LOCATION = 'PRODUCTION_STORAGE_LOCATION',
  // 计划边际码
  SCHEDULING_MARGIN_KEY = 'SCHEDULING_MARGIN_KEY',
  // 策略组
  POLICY_GROUP = 'POLICY_GROUP',
  // 综合MRP
  COMPREHENSIVE_MRP = 'COMPREHENSIVE_MRP',
  // 采购计划模式
  PROCUREMENT_PLAN_MODE = 'PROCUREMENT_PLAN_MODE',

  /* ---------  存储视图   --------- */
  // 发货单位
  // 负库存
  NEGATIVE_INVENTORY = 'NEGATIVE_INVENTORY',

  /* ---------  会计视图   --------- */
  // 价格控制指示符
  PRICE_CONTROL_INDICATOR = 'PRICE_CONTROL_INDICATOR',
  // 价格确认
  PRICE_CONFIRMATION = 'PRICE_CONFIRMATION',
  // 用QS计算成本
  CALCULATE_COSTS_USING_QS = 'CALCULATE_COSTS_USING_QS',
  // 不计算成本
  DO_NOT_CALCULATE_COSTS = 'DO_NOT_CALCULATE_COSTS',
  // 评估类
  EVALUATION_CLASS = 'EVALUATION_CLASS',
  /* ---------  工作计划视图   --------- */
  // 工作计划参数文件
  WORK_PLAN_PARAMETER_FILE = 'WORK_PLAN_PARAMETER_FILE',

  /* ---------  基础数据添加   --------- */
  // 料品形态
  MATERIAL_TYPE_STATUS = 'MATERIAL_TYPE_STATUS',

  /* ---------  物料属性添加   --------- */
  // 页面组件类型
  PAGE_COMPONENT_TYPE = 'PAGE_COMPONENT_TYPE',
  // 数据类型字典
  INPUT_DATA_TYPE = 'INPUT_DATA_TYPE',
  // 下拉组件绑定数据字典
  MATERIAL_ATTRIBUTE_SELECT_DICT = 'MATERIAL_ATTRIBUTE_SELECT_DICT',

  /* ---------  物料列表搜索区域   --------- */
  // 花色
  MATARIAL_DECOR = 'BOARD_DECOR',
  // 材质
  BASE_MATERIAL = 'BASE_MATERIAL',
  // 形态 ----料品形态(基础数据添加)
  // 状态
  MATERIAL_STATUS = 'MATERIAL_STATUS',
}

export enum ProductDirectoryEnum {
  // 销售单位
  BASE_UNIT = 'BASE_UNIT',
  // 组合标识
  PRO_SPU_GROUP_MARK = 'PRO_SPU_GROUP_MARK',
  // 下拉组件数据字典
  MATERIAL_ATTRIBUTE_SELECT_DICT = 'MATERIAL_ATTRIBUTE_SELECT_DICT',
  // 组件类型列表
  PAGE_COMPONENT_TYPE = 'PAGE_COMPONENT_TYPE',
}
